import { render, staticRenderFns } from "./Tissue.vue?vue&type=template&id=bbf898da&scoped=true"
import script from "./Tissue.vue?vue&type=script&lang=js"
export * from "./Tissue.vue?vue&type=script&lang=js"
import style0 from "./Tissue.vue?vue&type=style&index=0&id=bbf898da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf898da",
  null
  
)

export default component.exports